/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EnrolmentInputList } from '../../models/enrolment-input-list';
import { ImportResult } from '../../models/import-result';

export interface ApiEnrolmentSyncPost$Params {
      body: EnrolmentInputList
}

export function apiEnrolmentSyncPost(http: HttpClient, rootUrl: string, params: ApiEnrolmentSyncPost$Params, context?: HttpContext): Observable<StrictHttpResponse<ImportResult>> {
  const rb = new RequestBuilder(rootUrl, apiEnrolmentSyncPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ImportResult>;
    })
  );
}

apiEnrolmentSyncPost.PATH = '/api/enrolment/sync';
